import { render, staticRenderFns } from "./VerifyPassword.vue?vue&type=template&id=478a98e6&scoped=true&"
import script from "./VerifyPassword.vue?vue&type=script&lang=js&"
export * from "./VerifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPassword.vue?vue&type=style&index=0&id=478a98e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a98e6",
  null
  
)

export default component.exports